var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 29,
  rx: 14.5,
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 29,
  rx: 14.5,
  stroke: "black"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.2349 13.8515L21.6988 7.5H20.4041L15.6598 13.0149L11.8705 7.5H7.5L13.2301 15.8395L7.5 22.5H8.79485L13.805 16.6761L17.8067 22.5H22.1772L16.2346 13.8515H16.2349ZM14.4615 15.913L13.8809 15.0825L9.2614 8.47476H11.2502L14.9782 13.8075L15.5588 14.6379L20.4047 21.5696H18.4159L14.4615 15.9133V15.913Z",
  fill: "black"
})));
export default SvgIconTwitter;